<template>
  <div :class="{'compact-mode': isCompactMode}">
    <div>
      <el-card class="box-card">
        <div slot="header" class="subjectTitle">
          <div class="subjectName">
            <span class="question-number" v-if="subjectId !=null">{{ subjectId }}.</span>
            <div class="editor-content-view question-title-content">
              <div v-html="processedTitle"></div>
            </div>
          </div>
          <div class="answer-input-area">
            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="textarea" :disabled="isDis">
            </el-input>
          </div>
        </div>

        <div v-if="haveAnswer" class="answer-section">
          <!-- 答案信息区 -->
          <div class="answer-info">
            <!-- 标准答案 -->
            <div class="info-row standard-answer-row">
              <span class="label">标准答案</span>
              <span class="value answer-value" v-html="questionBody.correct"></span>
            </div>
            
            <!-- 结果 + 难度 -->
            <div class="info-row two-col">
              <div class="info-item">
                <span class="label">结果</span>
                <el-tag size="small" v-if="questionBody.answerInfo.doRight" type="success" effect="light">
                  <i class="el-icon-check"></i> 正确
                </el-tag>
                <el-tag size="small" v-else type="danger" effect="light">
                  <i class="el-icon-close"></i> 错误
                </el-tag>
              </div>
              <div class="info-item">
                <span class="label">难度</span>
                <el-rate v-model="questionBody.difficult" disabled class="difficulty-rate"></el-rate>
              </div>
            </div>
            
            <!-- 得分 + 得分率 -->
            <div class="info-row two-col">
              <div class="info-item">
                <span class="label">得分</span>
                <span class="value">
                  <span class="score-current">{{ questionBody.answerInfo.score }}</span>
                  <span class="score-divider">/</span>
                  <span class="score-total">{{ questionBody.score }}</span>
                </span>
              </div>
              <div class="info-item">
                <span class="label">得分率</span>
                <span class="value score-rate" :class="{'rate-success': questionBody.answerInfo.score > 0}">
                  {{ parseInt(questionBody.answerInfo.score / questionBody.score * 100) }}%
                </span>
              </div>
            </div>
          
            <!-- 解析区 -->
            <div class="info-row analysis-row">
              <span class="label">解析</span>
              <div class="analysis-content" v-html="questionBody.analyze"></div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subjectId: {
      type: Number,
      default: 1
    },
    isDis: {
      type: Boolean,
      default: false
    },
    questionBody: {
      type: Object,
      default: () => ({})
    },
    haveAnswer: {
      type: Boolean,
      default: false
    },
    chooseItem: {
      type: String,
      default: ""
    }
  },
  mounted() {
    // console.log(this.questionBody)

    if (this.haveAnswer) {
      // console.log(this.questionBody)
      this.textarea = this.questionBody.answerInfo.content

      // this.questionBody.items.forEach((item, index) => {
      // 	this.textarea = item.content
      // })
    }
  },
  watch: {
    textarea: {
      handler: function (n, o) {
        if (this.haveAnswer) {

        } else {
          // console.log(this.textarea)
          if (this.textarea) {
            // this.$emit("changed", this.subjectId)
            this.$emit("changed", {
              id: this.subjectId,
              name: this.radio,
              questionId: this.questionBody.id,
              content: this.textarea,
              contentArray: [],
              itemOrder: this.subjectId
            })
          } else {
            this.$emit("unchanged", {
              id: this.subjectId,
              name: this.textarea
            })
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      textarea: ""
    }
  },
  computed: {
    // 处理题目标题中的图片 URL
    processedTitle() {
      return this.$processImages(this.questionBody.title);
    },
    // 处理解析中的图片 URL
    processedAnalyze() {
      return this.$processImages(this.questionBody.analyze);
    },
    // 判断是否为紧凑模式（试卷页面）
    isCompactMode() {
      return this.$route.path === '/testPaperDetails';
    }
  }
}
</script>

<style lang="scss" scoped>

/* 紧凑模式下减少卡片左右间距（试卷页面） */
.compact-mode ::v-deep .el-card__header {
  padding-left: 0px;
  padding-right: 10px;
  border-bottom: none;
}

.compact-mode ::v-deep .el-card__body {
  padding-left: 0px;
  padding-right: 10px;
}

.subjectTitle {
  margin-bottom: -40px;
}

:deep(.editor-content-view pre) {
  word-wrap: normal;
  font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
  background-color: #F5F2F0;
  border-radius: 5px;
  margin-top: 5px;
  overflow-x: auto;
  font-size: 16px;
  line-height: 1.5;
  min-width: 750px;
  tab-size: 4;
}

:deep(.editor-content-view pre) {
  /*font-family: monospace;*/
  /*background-color: #eee;*/
  /*padding: 5px;*/
  /*border-radius: 3px;*/
}

/* 确保sub和sup标签被正确显示 */
::v-deep sub {
  vertical-align: sub;
  font-size: smaller;
}

::v-deep sup {
  vertical-align: super;
  font-size: smaller;
}

.subjectName {
  display: flex;
  align-items: flex-start;
  line-height: 1.6;

  .question-number {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .question-title-content {
    font-size: 18px;
    color: #303133;
    line-height: 1.6;
    letter-spacing: 0.3px;
  }

  p {
    font-size: 18px;
  }
}

.answer-input-area {
  padding-top: 18px;
}


/* 答案区域样式 */
.answer-section {
  margin: 20px 0 10px 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
}

.answer-info {
  padding: 12px 20px;
  background: #fafafa;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed #e8e8e8;

  &:last-child {
    border-bottom: none;
  }

  &.standard-answer-row {
    align-items: flex-start;
    
    .label {
      min-width: 70px;
      padding-top: 2px;
    }
    .answer-value {
      flex: 1;
      font-size: 14px;
      color: #409EFF;
      line-height: 1.6;
    }
  }

  &.two-col {
    display: flex;
    gap: 60px;
  }
}

.info-item {
  display: flex;
  align-items: center;
  min-width: 200px;
}

.label {
  font-size: 14px;
  color: #909399;
  margin-right: 12px;
  min-width: 50px;
}

.value {
  font-size: 14px;
  color: #333;
}

.score-current {
  font-weight: 600;
  color: #F56C6C;
  font-size: 16px;
}

.score-divider {
  margin: 0 4px;
  color: #c0c4cc;
}

.score-total {
  color: #909399;
}

.score-rate {
  font-weight: 600;
  color: #F56C6C;
  font-size: 16px;

  &.rate-success {
    color: #67C23A;
  }
}

.difficulty-rate {
  ::v-deep .el-rate__icon {
    font-size: 16px;
  }
}

/* 解析内容 */
.analysis-content {
  flex: 1;
  font-size: 14px;
  line-height: 1.8;
  color: #606266;

  &:empty::before {
    content: '暂无解析';
    color: #c0c4cc;
  }
}

.content {
  font-size: 14px;
  margin-top: 20px;
  color: #808080;
  display: flex;

  span {
    font-weight: 600;
    color: #000;
    line-height: 20px;
  }

  .classHtml {
    color: #808080;
  }
}
</style>
